import React from 'react'
import { Link } from 'react-router-dom'

import { SupplierBrand } from '../../../models'
import { PaginatedTableContract } from '../../common'

interface SupplierBrandsTableProps extends PaginatedTableContract {
    resources: {
        supplierBrands: SupplierBrand[]
    }
}

export const SupplierBrandsTable = (props: SupplierBrandsTableProps) => {
    const { resources } = props
    const { supplierBrands } = resources

    return (
        <table className='table'>
            <tbody>
                <tr>
                    <th>Brand Id</th>
                    <th>Brand Name</th>
                </tr>
                {supplierBrands.map(supplierBrand =>
                    <tr key={supplierBrand.id}>
                        <td>
                            {supplierBrand.id}
                        </td>
                        <td>
                            <Link to={`/suppliers/brands/${supplierBrand.id}`}>
                                {supplierBrand.name}
                            </Link>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    )
}
